import * as Types from 'types';

import { requestArtworks } from 'features/artworks/api';
import { receiveArtworks } from 'features/artworks/actions';

import { requestUsers } from 'features/users/api';
import { Actions as UsersActions } from 'features/users/actions';

import { fetchNextPage } from 'features/lists/actions';

import { getSearchResultsListId } from './helpers';

export const fetchArtworksByQuery =
  (query: string): Types.DefaultThunkAction =>
  (dispatch) => {
    const listId = getSearchResultsListId(query, 'artworks');

    dispatch(
      fetchNextPage(
        listId,
        ({ perPage, page }) => {
          return requestArtworks({
            filter: ['match', 'not_children'],
            match: query,
            order: 'alphabetical',
            page,
            perPage,
            parentId: null,
          });
        },
        {
          receiver: (data) => {
            dispatch(receiveArtworks(data));
          },
          perPage: 100,
        },
      ),
    );
  };

export const fetchArtistsByQuery =
  (query: string): Types.DefaultThunkAction =>
  (dispatch) => {
    const listId = getSearchResultsListId(query, 'artists');

    dispatch(
      fetchNextPage(
        listId,
        ({ perPage, page }) => {
          return requestUsers({
            filter: ['at', 'artists'],
            at: query,
            order: 'alphabetical',
            perPage,
            page,
          });
        },
        {
          receiver: (data) => {
            dispatch(UsersActions.receiveUserCards(data));
          },
          perPage: 100,
        },
      ),
    );
  };
